import { render, staticRenderFns } from "./SaleReturnDetailQuery.vue?vue&type=template&id=8b153ab2"
import script from "./SaleReturnDetailQuery.vue?vue&type=script&lang=js"
export * from "./SaleReturnDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports